var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "deviceSearch-heroshot mb-4 listing" }, [
    _c("h1", { staticClass: "d-block h2 mb-3 mb-lg-5 pb-0" }, [
      _vm._v("Blitzschnell die passende Sägekette finden"),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-container",
        class: _vm.additionalClass,
        attrs: { id: "seachCategoriesDropdown" },
      },
      [
        _c(
          "div",
          { staticClass: "dropdown" },
          [
            _c(
              "div",
              {
                staticClass: "dropdown-selected",
                on: {
                  click: function ($event) {
                    return _vm.toggleDropdown("manufacturer")
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.selectedManufacturer
                        ? _vm.selectedManufacturer.lang.de.name
                        : "Hersteller auswählen"
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _vm.showDropdown.manufacturer
                ? _c(
                    "div",
                    { staticClass: "dropdown-options" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.manufacturerSearch,
                            expression: "manufacturerSearch",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Hersteller suchen...",
                        },
                        domProps: { value: _vm.manufacturerSearch },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.manufacturerSearch = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _vm.filteredManufacturers,
                        function (manufacturer) {
                          return _c(
                            "div",
                            {
                              key: manufacturer.id,
                              staticClass: "dropdown-option",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.selectManufacturer(manufacturer)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(manufacturer.lang.de.name) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown",
            class: { disabled: !_vm.selectedManufacturer },
          },
          [
            _c(
              "div",
              {
                staticClass: "dropdown-selected",
                on: {
                  click: function ($event) {
                    return _vm.toggleDropdown("model")
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.selectedModel
                        ? _vm.selectedModel.lang.de.name
                        : "Modell auswählen"
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _vm.showDropdown.model
                ? _c(
                    "div",
                    { staticClass: "dropdown-options" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.modelSearch,
                            expression: "modelSearch",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Modell suchen...",
                        },
                        domProps: { value: _vm.modelSearch },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.modelSearch = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.filteredModels, function (model) {
                        return _c(
                          "div",
                          {
                            key: model.id,
                            staticClass: "dropdown-option",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.selectModel(model)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(model.lang.de.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown", class: { disabled: !_vm.selectedModel } },
          [
            _c(
              "div",
              {
                staticClass: "dropdown-selected",
                on: {
                  click: function ($event) {
                    return _vm.toggleDropdown("facet")
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.selectedFacet
                        ? _vm.selectedFacet.facet_value_name_de
                        : "Arbeitslänge auswählen"
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _vm.showDropdown.facet
                ? _c(
                    "div",
                    { staticClass: "dropdown-options" },
                    _vm._l(_vm.filteredFacets, function (facet) {
                      return _c(
                        "div",
                        {
                          key: facet.facet_url_parameter_id,
                          staticClass: "dropdown-option",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectFacet(facet)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(facet.facet_value_name_de) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "parallax-banner" }, [
      _c("div", { staticClass: "parallax-layer layer1" }),
      _vm._v(" "),
      _c("div", { staticClass: "parallax-layer layer2" }),
      _vm._v(" "),
      _c("div", { staticClass: "parallax-overlay" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }